export default __webpack_public_path__ + "static/media/DayScheduler.8451224e.jpg";